import React from 'react';
import { Loader } from 'lucide-react';

const LoadingSpinner = ({
  size = 'md',
  fullScreen = false,
  message = 'Loading...',
  showMessage = true,
  color = 'prose-brand',
}) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-10 h-10',
    lg: 'w-16 h-16',
  };

  const containerClasses = fullScreen
    ? 'fixed inset-0 bg-white/80 flex items-center justify-center z-50'
    : 'flex flex-col items-center justify-center h-96';

  return (
    <div className={containerClasses}>
      <div className="flex flex-col items-center space-y-3">
        <Loader
          className={`${sizeClasses[size]} text-${color} animate-spin`}
        />
        {showMessage && (
          <p className="text-sm text-prose-black/60 text-center">{message}</p>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;
